import { AbilityPricelistListDTO } from '../ability-pricelist/ability-pricelist-list.dto';
import { TenantConnectionDTO } from './tenant-connection.dto';

export class TenantDTO {

    id: string;

    name: string;

    active: boolean;

    sponsored: boolean;

    trial: boolean;

    vatNo: string;

    contactFirstName: string;

    contactLastName: string;

    contactEmail: string;

    contactPhone: string;

    billingFirstName: string;

    billingLastName: string;

    billingEmail: string;

    billingPhone: string;

    billingAddress: string;

    billingCity: string;

    billingZip: string;

    billingCountry: number;

    costCenter: string;

    registrationReferer: string;

    newsletter: boolean;

    verified: boolean;

    verificationCode: string;

    regIp: string;

    regAgent: string;

    invoiceBy: number;

    smsCount: number;

    emailCount: number;

    appCount: number;

    phoneSupport: boolean;

    createdAt?: Date;

    updatedAt?: Date;

    users: Array<TenantConnectionDTO>;

    pricelist: AbilityPricelistListDTO;

}
